import styled from "styled-components"

const Container = styled.div `
    width: 100%;
    height: 100vh;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    background-color: #190D17
`

export default Container;